import React from 'react';
import './CheckinSuccessPopup.css';
import { KilobaSpecies, UserKiloba } from '../types';

interface CheckinSuccessPopupProps {
  onClose: () => void;
  energyAmount: number;
  kilobaReward?: {
    species: KilobaSpecies;
    userKiloba: UserKiloba;
  };
}

const CheckinSuccessPopup: React.FC<CheckinSuccessPopupProps> = ({ onClose, energyAmount, kilobaReward }) => {
  const energyIcon = '/images/energy-icon.svg';

  // Function to get Kiloba image path with fallback
  const getKilobaImagePath = (code: string) => {
    const imagePath = `/images/kilohub/${code.toLowerCase()}.png`;
    return imagePath;
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="success-popup-overlay" onClick={handleOverlayClick}>
      <div className="success-popup-modal" onClick={(e) => e.stopPropagation()}>
        <div className="success-popup-content">
          <h2 className="success-title">
            {kilobaReward ? 'Điểm danh đặc biệt thành công!' : 'Điểm danh thành công'}
          </h2>
          
          <div className="reward-display">
            {/* Energy Reward */}
            <div className="reward-item">
              <div className="reward-icon-container">
                <img src={energyIcon} alt="Energy" className="reward-icon" />
              </div>
              <p className="reward-text">+{energyAmount} Năng Lượng</p>
            </div>
            
            {/* Kiloba Reward for Day 7 */}
            {kilobaReward && (
              <div className="reward-item kiloba-reward">
                <div className="kiloba-reward-container">
                  <div className="kiloba-image-container">
                    <img 
                      src={getKilobaImagePath(kilobaReward.species.code)}
                      alt={kilobaReward.species.name}
                      className="kiloba-image"
                      onError={(e) => {
                        // Fallback to default Kiloba image if specific image not found
                        e.currentTarget.src = '/images/kilohub/kiloba_toannang.png';
                      }}
                    />
                  </div>
                  <div className="kiloba-info">
                    <h3 className="kiloba-name">{kilobaReward.species.name}</h3>
                    <p className="kiloba-description">{kilobaReward.species.description}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <p className="upgrade-prompt">Hãy truy cập KILOHUB để nâng cấp KILOBA ngay nhé</p>
          
          <button className="close-success-button" onClick={onClose}>
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckinSuccessPopup;
